import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import "./AssignAssistantModal.scss";
import {
  PlayerBadge,
  PrimaryButton,
  SuccessButton,
  DismissButton,
  DarkScreenMask,
  MemberDetails
} from "../../..";
import { WHITE, GREEN_LIGHT } from "../../../styles/shared/colors";
import closeIcon from '../../../assets/imgs/icon-close.svg';

class AssignAssistantModal extends Component {
  static propTypes = {
    isVisible: PropTypes.bool,
    members: PropTypes.object,
    onClose: PropTypes.func,
    onApprove: PropTypes.func
  };

  static defaultProps = {
    isVisible: false,
    members: {},
    onClose: () => {},
    onApprove: () => {}
  };

  state = {
    assistant: null,
    isDone: false
  };

  renderTeamList = () => {
    const { members } = this.props;
    const assignButton = {
      color: WHITE,
      background: GREEN_LIGHT,
      width: "57px",
      height: "23px",
      fontSize: "12px"
    };

    return (
      <Fragment>
        <p className="assign-assistant__list-title">
          Assign Assistant
        </p>
        <ul className="assign-assistant__list">
          {members &&
            Object.keys(members)
              .sort()
              .map(memberType => (
                <Fragment key={memberType}>
                  {members[memberType].map(member => (
                    <li key={member._id} className="assign-assistant__row">
                      <MemberDetails member={member} />
                      <PrimaryButton
                        style={assignButton}
                        onClick={() => {
                          this.setState({ assistant: member });
                        }}
                      >
                        Assign
                      </PrimaryButton>
                    </li>
                  ))}
                </Fragment>
              ))}
        </ul>
      </Fragment>
    );
  };

  renderApproveAssign = () => {
    const {
      firstName,
      lastName,
      fullName,
      avatar,
      avatarBgColor
    } = this.state.assistant;

    const { isDone } = this.state;
    return (
      <div className="assign-assistant__approve-container">
        <div className="assign-assistant__approve-container__image">
          {avatar ? (
            <img src={avatar} />
          ) : (
              <PlayerBadge
                firstName={firstName}
                lastName={lastName}
                color={avatarBgColor}
                fontSize="48px"
              />
            )}
        </div>
        {!isDone ? (
          <Fragment>
            <p className="assign-assistant__approve-container__assign-title">
              Do you want to assign
              <b className="assign-assistant__approve-container__assign-title__name">{fullName}</b>
              as game assistant?
            </p>
            <div>
              <DismissButton
                onClick={() => {
                  this.setState({ assistant: null });
                }}
              >
                Cancel
              </DismissButton>
              <SuccessButton onClick={this.handleAssignApprove}>
                Yes
              </SuccessButton>
            </div>
          </Fragment>
        ) : (
            <div>
              <p className="assign-assistant__approve-container__assign-title">
                <b>{fullName}</b>
                Was assigned as game assistant
            </p>
            </div>
          )}
      </div>
    );
  };

  handleAssignApprove = () => {
    const { onApprove } = this.props;
    const { assistant } = this.state;
    onApprove(assistant._id);
  };

  render() {
    const { isVisible, onClose } = this.props;
    const { assistant } = this.state;
    return (
      <DarkScreenMask
        isVisible={isVisible}
      >
        <div className="assign-assistant">
          <button className="assign-assistant__close-icon" onClick={onClose}>
            <img src={closeIcon} alt="" />
          </button>
          {assistant ? this.renderApproveAssign() : this.renderTeamList()}
        </div>
      </DarkScreenMask>
    )
  }
}

export default AssignAssistantModal;
